import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";
import WelcomeSweetener from "../components/shared/WelcomeSweetener";

export default function Signup() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [welcomeName, setWelcomeName] = useState(null); // null = hidden, string = show modal
  const { signup } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return toast.error("Password must be 6+ characters");
    setLoading(true);
    try {
      await signup(form);
      setWelcomeName(form.name || "");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  const ch = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="pt-32 pb-20 min-h-[80vh] flex items-center" data-testid="signup-page">
      <div className="container-x max-w-md mx-auto">
        <div className="doodle-card p-8 bg-white">
          <div className="w-14 h-14 bg-[#E7F4FF] border-2 border-[#2D2424] rounded-full flex items-center justify-center mx-auto" style={{ boxShadow: "3px 3px 0 #2D2424" }}>
            <UserPlus className="w-6 h-6 text-[#7A1F2B]" strokeWidth={2}/>
          </div>
          <h1 className="font-doodle text-4xl text-center mt-4 text-[#2D2424]">Join the family! 🎁</h1>
          <p className="text-center text-sm font-hand text-[#5C5555] mt-1">Sign up &amp; get a FREE handwritten note on your first hamper</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input required placeholder="Full Name" value={form.name} onChange={ch("name")} data-testid="signup-name" className="w-full border-2 border-[#2D2424] px-4 py-3 focus:outline-none rounded-lg"/>
            <input required type="email" placeholder="Email" value={form.email} onChange={ch("email")} data-testid="signup-email" className="w-full border-2 border-[#2D2424] px-4 py-3 focus:outline-none rounded-lg"/>
            <input type="tel" placeholder="Phone (optional)" value={form.phone} onChange={ch("phone")} data-testid="signup-phone" className="w-full border-2 border-[#2D2424] px-4 py-3 focus:outline-none rounded-lg"/>
            <input required type="password" placeholder="Password (min 6 characters)" value={form.password} onChange={ch("password")} data-testid="signup-password" className="w-full border-2 border-[#2D2424] px-4 py-3 focus:outline-none rounded-lg"/>
            <button type="submit" disabled={loading} data-testid="signup-submit" className="btn-primary w-full">
              {loading ? "Creating…" : "Create Account"}
            </button>
          </form>
          <p className="text-center text-sm font-hand text-[#5C5555] mt-6">
            Already have an account? <Link to="/login" className="text-[#7A1F2B] underline">Sign in</Link>
          </p>
        </div>
      </div>
      {welcomeName !== null && (
        <WelcomeSweetener
          userName={welcomeName}
          onClose={() => { setWelcomeName(null); navigate("/account"); }}
        />
      )}
    </div>
  );
}
